import { createI18n } from 'vue-i18n';
import common from './locales/common';
import login from './locales/login';
import header from './locales/header';
import user from './locales/user';
import device from './locales/device';
import resource from './locales/resource';
import account from './locales/account';
import role from './locales/role';
import dict from './locales/dict';
import global from './locales/global';
import customDevice from './locales/customDevice';
import customAccount from './locales/customAccount';
import customOrganManage from './locales/customOrganManage';
import deviceConfig from './locales/deviceConfig';
import situationMap from './locales/situationMap';
import videoMatrix from './locales/videoMatrix';
import resourceCenter from './locales/resourceCenter';
import packageModule from './locales/package';
import roleManage from './locales/roleManage';

// 从 localStorage 读取用户选择的语言，默认为 zh-cn
const getDefaultLocale = () => {
  const savedLocale = localStorage.getItem('app-locale');
  if (savedLocale && ['zh-cn', 'en', 'zh-tw'].includes(savedLocale)) {
    return savedLocale;
  }
  return 'zh-cn';
};

// 工具函数：将模块的合并格式转换为按语言切分的格式
function splitModuleByLocale(module: any): { 'zh-cn': any, 'zh-tw': any, 'en': any } {
  const result = {
    'zh-cn': {} as any,
    'zh-tw': {} as any,
    'en': {} as any
  };
  
  function traverse(obj: any, target: any) {
    for (const key in obj) {
      const value = obj[key];
      
      if (value && typeof value === 'object' && 'zh-cn' in value && 'zh-tw' in value && 'en' in value) {
        // 找到语言对象，切分到对应语言
        target['zh-cn'][key] = value['zh-cn'];
        target['zh-tw'][key] = value['zh-tw'];
        target['en'][key] = value['en'];
      } else if (value && typeof value === 'object' && !Array.isArray(value)) {
        // 继续递归处理嵌套对象
        target['zh-cn'][key] = {};
        target['zh-tw'][key] = {};
        target['en'][key] = {};
        traverse(value, {
          'zh-cn': target['zh-cn'][key],
          'zh-tw': target['zh-tw'][key],
          'en': target['en'][key]
        });
      }
    }
  }
  
  traverse(module, result);
  return result;
}

// 合并所有模块
const modules = {
  common,
  login,
  header,
  user,
  device,
  resource,
  account,
  role,
  dict,
  global,
  customDevice,
  customAccount,
  customOrganManage,
  deviceConfig,
  situationMap,
  videoMatrix,
  resourceCenter,
  package: packageModule,
  roleManage
};

const messages = {
  'zh-cn': {} as any,
  'zh-tw': {} as any,
  'en': {} as any
};

// 遍历每个模块，切分并合并
for (const moduleName in modules) {
  const split = splitModuleByLocale(modules[moduleName as keyof typeof modules]);
  messages['zh-cn'][moduleName] = split['zh-cn'];
  messages['zh-tw'][moduleName] = split['zh-tw'];
  messages['en'][moduleName] = split['en'];
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-cn',
  messages
});

// 更新页面 title
const updateDocumentTitle = () => {
  document.title = i18n.global.t('header.projectName');
};

// 导出切换语言的方法
export const setLocale = (locale: 'zh-cn' | 'en' | 'zh-tw') => {
  i18n.global.locale.value = locale;
  localStorage.setItem('app-locale', locale);
  // 更新页面 title
  updateDocumentTitle();
};

// 导出当前语言
export const getLocale = () => {
  return i18n.global.locale.value;
};

// 导出更新 title 的方法，供外部调用
export const updateTitle = () => {
  updateDocumentTitle();
};

export default i18n;
